import Button from '../ui/Button.jsx';

const Content = ({ ...props }) => {
    const { heading, breaking_image, image, subheading, text, button, fn } = props;

    return (
        <div className="row relative justify-center">
            <div className="col lg:w-8/12 xl:w-6/12">
                <div className="component-content">
                    {breaking_image && <img src={breaking_image} height="138" className="absolute right-3 h-32" />}
                    <h1 className={breaking_image ? 'mb-40 text-5xl' : 'mb-10 text-5xl'}>{heading}</h1>
                    {image && <img src={image} className="mx-auto my-10" />}
                    <h2 className="text-4xl">{subheading}</h2>
                    <div className="text" dangerouslySetInnerHTML={{ __html: text }}></div>

                    {button && (
                        <div className="mt-12">
                            <Button {...button} onClick={() => fn.handleAction(button.action)} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Content;
